/*! @azure/msal-common v6.3.0 2022-05-02 */
'use strict';
/* eslint-disable header/header */
var name = "@azure/msal-common";
var version = "6.3.0";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
